/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_SearchingInputs */

const en_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const fr_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const de_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const it_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const ru_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const es_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const zh_cn2_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const ja_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const hi_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

const pt_pt2_explorer_search_searching = /** @type {(inputs: Explorer_Search_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching...`)
};

/**
* | output |
* | --- |
* | "Searching..." |
*
* @param {Explorer_Search_SearchingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_searching = /** @type {((inputs?: Explorer_Search_SearchingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_SearchingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_searching(inputs)
	if (locale === "de") return de_explorer_search_searching(inputs)
	if (locale === "it") return it_explorer_search_searching(inputs)
	if (locale === "ru") return ru_explorer_search_searching(inputs)
	if (locale === "es") return es_explorer_search_searching(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_searching(inputs)
	if (locale === "ja") return ja_explorer_search_searching(inputs)
	if (locale === "hi") return hi_explorer_search_searching(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_searching(inputs)
	return en_explorer_search_searching(inputs)
});